import CreditPolicyViolation from './CreditPolicyViolation'

export default CreditPolicyViolation
